<!-- Subheader Start -->
<breadcrumb #parent>
    <div class="subheader dark-overlay dark-overlay-2" style="background-image: url('assets/img1/shawrma_background_1.png')">
        <div class="container">
            <div class="subheader-inner">
                <ng-template ngFor let-route [ngForOf]="parent.breadcrumbs">
                    <h1>{{ route.displayName }}</h1>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a routerLink="/">Home</a></li>
                            <li *ngIf="!route.terminal" class="breadcrumb-item">
                                <a href="" [routerLink]="[route.url]">{{ route.displayName }}</a>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">{{ route.displayName }}</li>
                        </ol>
                    </nav>
                </ng-template>
            </div>
        </div>
    </div>
</breadcrumb>
<!-- Subheader End -->